<template>
    <div class="flex-preview">
        <component :is="component" />
    </div>
</template>

<script>
export default {
    name: 'preview',

    props: {
        component: {
            type: String,
            default: '',
        },
    },
};
</script>
